var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThesaurusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28125 18C2.35938 18 1.58203 17.6963 0.949219 17.0888C0.316406 16.4813 0 15.735 0 14.85V3.15C0 2.28 0.316406 1.5375 0.949219 0.9225C1.58203 0.3075 2.35938 0 3.28125 0H15V13.5C14.5937 13.5 14.2578 13.6313 13.9922 13.8938C13.7266 14.1563 13.5938 14.475 13.5938 14.85C13.5938 15.24 13.7266 15.5625 13.9922 15.8175C14.2578 16.0725 14.5937 16.2 15 16.2V18H3.28125ZM3.28125 16.2H12.0234C11.9297 15.99 11.8555 15.7763 11.8008 15.5588C11.7461 15.3413 11.7188 15.105 11.7188 14.85C11.7188 14.61 11.7422 14.3775 11.7891 14.1525C11.8359 13.9275 11.9141 13.71 12.0234 13.5H3.28125C2.875 13.5 2.53906 13.6313 2.27344 13.8938C2.00781 14.1563 1.875 14.475 1.875 14.85C1.875 15.24 2.00781 15.5625 2.27344 15.8175C2.53906 16.0725 2.875 16.2 3.28125 16.2ZM1.875 11.9925C2.09375 11.8875 2.31641 11.8125 2.54297 11.7675C2.76953 11.7225 3.01563 11.7 3.28125 11.7H13.125V1.8H3.28125C2.875 1.8 2.53906 1.93125 2.27344 2.19375C2.00781 2.45625 1.875 2.775 1.875 3.15V11.9925ZM4.42969 9.9H5.57812L6.16406 8.3025H8.8125L9.39844 9.9H10.5469L8.0625 3.6H6.89062L4.42969 9.9ZM6.49219 7.38L7.45312 4.77H7.52344L8.48438 7.38H6.49219Z",
    fill: "#00BC92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThesaurusIcon);
export default __webpack_public_path__ + "static/media/thesaurusIcon.5fc658c01e53c6288b7890226e51fef9.svg";
export { ForwardRef as ReactComponent };